var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100 d-flex justify-content-center align-items-center align-middle"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h1',[_vm._v("Configuration manquante ou invalide")])])])])
}]

export { render, staticRenderFns }